import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdviceRecordForm from './AdviceRecordForm';
import StairsLoader from '../shared/StairsLoader';

export default class AdviceRecordModal extends Component {
  static propTypes = {
    authenticityToken: PropTypes.string.isRequired,
    adviceTypes: PropTypes.object.isRequired,
    header: PropTypes.string.isRequired,
    subHeader: PropTypes.string.isRequired,
    adviceRecordId: PropTypes.number,
    tenant: PropTypes.string.isRequired,
    clientId: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      requestState: this.initialModalContent
    };
  }

  requestStateCallback = (requestState) => {
    this.setState({ requestState: this[requestState] });
  }

  progress = () => {
    return (
      <div className="advice-record">
        <div className="modal__header">
          <h1>{this.props.header}</h1>
        </div>
        <div className="modal__sub-header">
          <h3>Upload in progress...</h3>
        </div>
        <div className="modal__main center" style={{minHeight: 0}}>
          <StairsLoader />
        </div>
      </div>
    );
  }

  error = () => {
    return (
      <div className="advice-record">
        <div className="modal__header">
          <h1>{this.props.header}</h1>
        </div>
        <div className="modal__sub-header">
          <h3>Oops, something went wrong.</h3>
        </div>
        <div className="modal__main text-center" style={{minHeight: 0}}>
          <p>We failed to upload your file and create the advice record, please try again.</p>
          <a href="#" data-close="" className="button button--primary" onClick={() => { this.setState({ requestState: this.initialModalContent }) }}>Close</a>
        </div>
      </div>
    );
  }

  initialModalContent = () => {
    return (
      <div className="advice-record">
        <div className="modal__header">
          <button className="close-button" aria-label="Close modal" data-close="" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
          <h1>{this.props.header}</h1>
        </div>
        <div className="modal__sub-header">
          <h3>{this.props.subHeader}</h3>
        </div>
        <div className="modal__main center">
          <AdviceRecordForm
            adviceRecordId={this.props.adviceRecordId}
            requestStateCallback={this.requestStateCallback}
            authenticityToken={this.props.authenticityToken}
            adviceTypes={this.props.adviceTypes}
            tenant={this.props.tenant}
            clientId={this.props.clientId} />
        </div>
      </div>
    );
  }

  render() {
    return this.state.requestState()
  }
}
